/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Category_InactiveInputs */

const en_cases_settings_category_inactive = /** @type {(inputs: Cases_Settings_Category_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Cases_Settings_Category_InactiveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cases_settings_category_inactive = /** @type {((inputs?: Cases_Settings_Category_InactiveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_InactiveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_inactive(inputs)
});